import React from 'react'
import type { AutocompleteOption } from './Autocomplete.types'

export const filterAutocompleteOptions = (
  options: AutocompleteOption[],
  query: string,
): AutocompleteOption[] => {
  const normalizedQuery = query.trim().toLowerCase()

  if (!normalizedQuery) {
    return options
  }

  return options.filter((option) =>
    option.label.toLowerCase().includes(normalizedQuery),
  )
}

/** Split `text` into nodes with matching substrings wrapped for highlight styling. */
export const highlightAutocompleteMatches = (
  text: string,
  query: string,
): React.ReactNode => {
  const normalizedQuery = query.trim()

  if (!normalizedQuery) {
    return text
  }

  const lowerText = text.toLowerCase()
  const lowerQuery = normalizedQuery.toLowerCase()
  const nodes: React.ReactNode[] = []
  let start = 0
  let matchIndex = lowerText.indexOf(lowerQuery)

  while (matchIndex !== -1) {
    if (matchIndex > start) {
      nodes.push(text.slice(start, matchIndex))
    }

    nodes.push(
      <mark
        key={`${matchIndex}-${normalizedQuery}`}
        className="ds-autocomplete__match"
      >
        {text.slice(matchIndex, matchIndex + normalizedQuery.length)}
      </mark>,
    )

    start = matchIndex + normalizedQuery.length
    matchIndex = lowerText.indexOf(lowerQuery, start)
  }

  if (start < text.length) {
    nodes.push(text.slice(start))
  }

  return nodes.length > 0 ? nodes : text
}
